import { z } from "zod";

/** Respostas prontas da mudança de prazo pelo laboratório — a pessoa escolhe uma e pode completar. */
export const MOTIVOS_DA_MUDANCA_DE_PRAZO = [
  "Combinado com a clínica",
  "Fila de produção",
  "Falta de material",
  "Aguardando informação da clínica",
] as const;

/** O laboratório muda o prazo do pedido inteiro. Data sem hora (meia-noite local, como no envio). */
export const alterarPrazoDoPedidoSchema = z.object({
  orderId: z.string().min(1),
  deadline: z.coerce.date(),
  motivo: z.string().trim().max(300).optional(),
});
export type AlterarPrazoDoPedidoInput = z.infer<typeof alterarPrazoDoPedidoSchema>;
